import { useEffect, useState } from "react";
import { trackWhatsAppClick } from "../trackWhatsApp";

const Hero = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <section
      id="inicio"
      className="relative h-screen w-full overflow-hidden"
      style={{
        backgroundImage: `
          linear-gradient(
            to bottom,
            rgba(0,0,0,0.40),
            rgba(0,0,0,0.45)
          ),
          url('/images/hero-desktop-v2.webp')
        `,
        backgroundSize: "cover",
        backgroundPosition: "40% 22%",
      }}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_40%,rgba(0,0,0,0.35)_100%)]" />
      <div className="relative z-10 h-full flex items-center justify-center px-6">
        <div
          className={`max-w-3xl text-center space-y-6 transition-all duration-1000 ${
            loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="flex justify-center">
            <img
              src="/images/logo-simple.webp"
              alt="Marcos Jones Marcenaria"
              width="80"
              height="64"
              className="h-16 md:h-20 object-contain"
            />
          </div>
          <span className="block text-lg tracking-[0.2em] text-wood-400 uppercase">
            Marcenaria
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-wood-400 leading-tight">
            Realizamos o sonho
            <br />
            <strong className="font-semibold text-wood-400 ">
              {" "}
              você vive o resultado
            </strong>
          </h1>
          <p className="text-military-500 max-w-xl mx-auto text-base md:text-lg font-semibold">
            Criamos móveis planejados personalizados, combinando design,
            funcionalidade e exclusividade.
          </p>

          <div className="pt-4">
            <a
              href="https://wa.me/5511974957987?text=Olá!%20Gostaria%20de%20um%20orçamento%20de%20móvel%20sob%20medida."
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsAppClick("hero")}
              className="inline-flex items-center justify-center px-8 py-4 border border-wood-500 bg-wood-500 text-wood-300 rounded-full hover:bg-wood-500/70 hover:text-military-200 transition-all duration-300 font-semibold"
            >
              Solicitar orçamento
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="opacity-0 md:opacity-100 w-8 h-12 border-2 border-military-400 rounded-full flex justify-center animate-bounce">
          <div className="w-1 h-3 bg-military-400 rounded-full mt-2 animate-pulse"></div>
        </div>
        <div className="md:opacity-0 opacity-100 animate-bounce">
          <svg
            width="40"
            height="60"
            viewBox="0 0 40 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="5"
              y="10"
              width="30"
              height="40"
              rx="5"
              stroke="#4A5D3A"
              strokeWidth="2"
              fill="none"
            />
            <rect x="12" y="15" width="16" height="2" fill="#4A5D3A" />
            <circle cx="20" cy="35" r="1" fill="#4A5D3A" />
            <path d="M20 45 L20 55 L18 53 L22 53 Z" fill="#4A5D3A" />
            <circle cx="20" cy="50" r="2" fill="#4A5D3A" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Hero;
